'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PleasurecraftIcon = function (_React$Component) {
    _inherits(PleasurecraftIcon, _React$Component);

    function PleasurecraftIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PleasurecraftIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PleasurecraftIcon.__proto__ || Object.getPrototypeOf(PleasurecraftIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'pleasurecraft-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, transform: 'translate(0)', fill: '#fff', opacity: '0' }),
                _react2.default.createElement('path', { id: 'Path_43692', 'data-name': 'Path 43692', fill: color, d: 'M680.776,387.214a4.549,4.549,0,0,1-1.455.636,1.05,1.05,0,0,1-.453.068l-10.547,1.128a.7.7,0,0,1-.5-.212.585.585,0,0,0-.451-.212l-5.424.072a.966.966,0,0,1-1-.776l-.151-1.556c3.615-.072,17.731-.769,22.4-2.318a23.116,23.116,0,0,1-2.411,3.17Zm-20.037-3.026c0-.144.354-.436.55-.857l.355-1.047a.49.49,0,0,1,.3-.28c6.429-.7,5.676-.633,6.078-.633a29.094,29.094,0,0,1,.7-4.37.437.437,0,0,0-.2-.492l-2.36-.421h-.1l-.3-.284a.415.415,0,0,1-.1-.28.164.164,0,0,1,.049-.14c.051-.072.1-.144.151-.144,5.927-.913,8.589.072,9.342.424a.785.785,0,0,1,.351.492,1.59,1.59,0,0,0,.2.424c.653.633,3.113,3.17,4.269,4.367l4.471-.14c.149,0,.251.28.149.421a15.28,15.28,0,0,1-1.455,2.818c-3.364,1.621-18.431,2.465-22.4,2.537A8.7,8.7,0,0,1,660.739,384.188Zm9.14-3.666c5.324-.633,3.818-.421,7.131-.845.051,0,.1-.14.051-.212l-2.562-2.958a.6.6,0,0,0-.3-.14H670.33c-.1,0-.2.14-.251.28l-.451,3.454a.333.333,0,0,0,.251.421Zm0,0', transform: 'translate(-660.684 -370.238)' })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PleasurecraftIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return PleasurecraftIcon;
}(_react2.default.Component);

exports.default = PleasurecraftIcon;